document.addEventListener('DOMContentLoaded', function () {
	const detailButtons = document.querySelectorAll(
		'.ocbee-event-item-details',
	);

	const modals = document.querySelectorAll('.ocbee-event-item-details-modal');
	if (!detailButtons.length || !modals.length) {
		return;
	}

	detailButtons.forEach((btn, index) => {
		const modal = modals[index];
		if (!modal) {
			return;
		}

		btn.addEventListener('click', () => {
			modal.classList.add('is-open');
			document.body.classList.add('modal-open'); // optional: lock scroll
		});

		const closeButton = modal.querySelector(
			'.ocbee-event-item-details-modal-close',
		);
		if (closeButton) {
			closeButton.addEventListener('click', () => {
				modal.classList.remove('is-open');
				document.body.classList.remove('modal-open');
			});
		}

		// Optional: Close modal on Escape key
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && modal.classList.contains('is-open')) {
				modal.classList.remove('is-open');
				document.body.classList.remove('modal-open');
			}
		});
	});
});
